import { render } from "./HamburgerIcon.vue?vue&type=template&id=19c4b670"
import script from "./HamburgerIcon.vue?vue&type=script&lang=js"
export * from "./HamburgerIcon.vue?vue&type=script&lang=js"
script.render = render

export default script